import { createSvgIcon } from "@material-ui/core";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -960 960 960",
  children: /*#__PURE__*/_jsx("path", {
    d: "m749-319-60-60v-356h-87v269l-60-60v-254H288l-60-60h374v45h147v476Zm81 252L602-295v175H120v-60h92v-506L85-812l43-43 745 745-43 43ZM272-180h270v-176L272-626v446Zm143-473Zm-8 162Z"
  })
}), "NoMeetingRoom");